import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
    EPaymentProfileActionType,
    IFetchPaymentProfileAction,
    IPostPaymentProfileAction,
} from 'modules/PaymentProfile';
import { AxiosResponse } from 'axios';
import axiosInstance from 'helpers/axiosInstance';
import { ENotificationType } from 'stores/reducers/notification/type';
import { isPostCreditCard } from 'helpers/paymentProfile';
import { SagaIterator } from 'redux-saga';

export function* FetchPaymentProfileAsync(action: IFetchPaymentProfileAction) {
    let data: AxiosResponse<unknown>;
    try {
        data = yield call(axiosInstance.get, '/api/payment-profiles', {
            params: action.payload.params,
        });

        yield put({ type: EPaymentProfileActionType.FETCH_SUCCEEDED, data: data.data });
    } catch (error) {
        yield put({ type: EPaymentProfileActionType.FETCH_FAILED, error: error.message });
        return;
    }
}
export function* PostPaymentProfileAsync(action: IPostPaymentProfileAction) {
    let data: AxiosResponse<unknown>;
    const url = isPostCreditCard(action.payload.data)
        ? '/api/payment-profiles/credit-card'
        : '/api/payment-profiles/direct-debit';
    try {
        data = yield call(axiosInstance.post, url, action.payload.data, {
            params: action.payload.params,
        });

        yield put({
            type: EPaymentProfileActionType.POST_SUCCEEDED,
            data: data.data,
            message: action.meta?.successMessage,
        });
        yield put({ type: ENotificationType.Success, primaryMessage: action.meta?.successMessage });
    } catch (error) {
        yield put({ type: EPaymentProfileActionType.POST_FAILED, error: action.meta?.failureMessage });
        yield put({
            type: ENotificationType.Danger,
            primaryMessage: action.meta?.failureMessage,
            secondaryMessage: error.message,
        });
    }
}

export function* watchFetchPaymentProfileAsync() {
    yield takeLatest<EPaymentProfileActionType, (action: IFetchPaymentProfileAction) => void>(
        EPaymentProfileActionType.FETCH_REQUESTED,
        FetchPaymentProfileAsync,
    );
}
export function* watchPostPaymentProfileAsync() {
    yield takeLatest<EPaymentProfileActionType, (action: IPostPaymentProfileAction) => void>(
        EPaymentProfileActionType.POST_REQUESTED,
        PostPaymentProfileAsync,
    );
}

export default function* rootSaga(): SagaIterator {
    yield all([call(watchFetchPaymentProfileAsync), call(watchPostPaymentProfileAsync)]);
}
